<script lang="ts">
  import { onMount } from "svelte";

  import { Col, Container, Row } from "sveltestrap";
  import CounterNumber from "../../components/CounterNumber.svelte";
  import GithubButton from "../../components/GithubButton.svelte";
  import LearnMoreButton from "../../components/landing/LearnMoreButton.svelte";
  import { analytics, githubAppUrl } from "../../stores";

  let builds: number;
  let clients: number;

  onMount(() => {
    return analytics.subscribe((result) => {
      builds = result.builds;
      clients = result.clients;
    });
  });
</script>

<div class="background">
  <Container style="min-width: 90%;">
    <Row
      class="d-flex flex-wrap align-items-center justify-content-center"
      style="height: 85vh;"
    >
      <Col sm={5}>
        <h1>
          Continuous <span class="green-word">Testing</span> For Unity Projects<span
            class="green-word">.</span
          >
        </h1>
        <p class="description">
          Use your Unity Cloud setup to run automated tests on Pull Requests
        </p>
        <Row>
          <div class="builds-container statics">
            <div
              class="stat-content d-flex h-100 justify-content-around align-items-center"
            >
              <img
                height="32"
                width="32"
                src="images/landing/check.png"
                alt="check"
              />
              <span class="stat-number"><CounterNumber target={builds} /></span>
              <span>Builds Done</span>
            </div>
          </div>
        </Row>
        <Row>
          <div class="statics">
            <div
              class="stat-content d-flex h-100 justify-content-around align-items-center"
            >
              <img
                height="32"
                width="32"
                src="images/landing/user.png"
                alt="check"
              />
              <span class="stat-number"><CounterNumber target={clients} /></span
              >
              <span>Customers</span>
            </div>
          </div>
        </Row>
        <div class="row buttons-section">
          <Col>
            <GithubButton githubUrl={$githubAppUrl} />
          </Col>
          <Col>
            <LearnMoreButton />
          </Col>
        </div>
      </Col>
      <Col sm={5}>
        <div class="align-vertical">
          <img
            src={"/images/landing/check-running.png"}
            alt={"check-running"}
            class="feature-image"
          />
        </div>
      </Col>
    </Row>
  </Container>
</div>

<style>
  .background {
    min-height: 94vh;
    padding-top: 60px;
  }

  h1 {
    font-family: Montserrat;
    font-style: normal;
    font-size: 52px;
    line-height: 76px;
    font-weight: bold;
    text-transform: capitalize;
    color: #2f2e34;
    text-align: left;
  }

  .green-word {
    color: #3a9949;
  }

  .description {
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 184%;
    color: #2f2e34;
    text-align: left;
  }

  .statics {
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    text-transform: capitalize;
    color: #2f2e34;
    width: 348px;
    height: 73px;
    justify-content: center;
    display: table-cell;
    vertical-align: middle;
  }

  .stat-number {
    font-family: Rubik;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 43px;
  }

  .builds-container {
    background: #ffffff;
    border-radius: 4px;
  }

  .align-vertical {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .align-vertical img {
    width: 100%;
  }

  .feature-image {
    width: 100%;
  }

  .buttons-section {
    margin-top: 50px;
  }
</style>
